import { render } from "./Bullets.vue?vue&type=template&id=58fd50a4"
import script from "./Bullets.vue?vue&type=script&lang=ts"
export * from "./Bullets.vue?vue&type=script&lang=ts"
script.render = render

export default script